import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AiFillSetting } from "react-icons/ai";
import { BsCollection, BsPencil } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { FaWallet } from "react-icons/fa";
import { MdKeyboardArrowDown, MdLogout, MdOutlineDarkMode } from "react-icons/md";
import "./ProfileMenu.css";

const shortAddress = (wallet) => `${wallet.slice(0, 6)}...${wallet.slice(-4)}`;

/**
 * The header's account control. Signed out: a "Connect Wallet" button.
 * Signed in: the avatar and name; hovering (or clicking, for touch screens)
 * opens the account menu.
 */
export default function ProfileMenu({
  UserWallet,
  name,
  logolink,
  onConnect,
  logout,
  toggleTheme,
  className = "",
}) {
  const [open, setOpen] = useState(false);

  if (!UserWallet) {
    return (
      <div className={`${className} pm-trigger`} onClick={onConnect} role="button">
        <FaWallet className="b-c-t f-s-1_5" />
        <span className="w-s-n-w p-x-1">Connect Wallet</span>
      </div>
    );
  }

  return (
    <div
      className="pm-wrap"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {/* The pill styles clip their content (overflow: hidden), so they go on the
          trigger, not on the wrapper the menu hangs from. */}
      <div
        className={`${className} pm-trigger`}
        role="button"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        {logolink ? (
          <img src={logolink} className="pm-avatar" alt="" />
        ) : (
          <CgProfile className="b-c-t f-s-1_5" />
        )}
        <span className="w-s-n-w p-x-0_5">{name || "Profile"}</span>
        <MdKeyboardArrowDown className={`pm-caret ${open ? "pm-caret-open" : ""}`} />
      </div>
      {open ? (
        <div className="profile23 pm-menu" role="menu">
          <div className="pm-head">
            <div className="pm-head-name">{name || "Unnamed"}</div>
            <div className="pm-head-wallet">{shortAddress(UserWallet)}</div>
          </div>
          <div className="l-s-t-n">
            <Link to={`/profile/${name}/${UserWallet}`} onClick={() => setOpen(false)}>
              <li className="hover_effect w-s-n-w p-y-1 p-x-1" role="menuitem">
                <CgProfile className="b-c-t" />
                &nbsp; Profile
              </li>
            </Link>
            <a href="/createnft">
              <li className="hover_effect w-s-n-w p-y-1 p-x-1" role="menuitem">
                <BsPencil className="b-c-t" />
                &nbsp; Create
              </li>
            </a>
            <a href="/mycollections">
              <li className="hover_effect w-s-n-w p-y-1 p-x-1" role="menuitem">
                <BsCollection className="b-c-t" />
                &nbsp; My Collection
              </li>
            </a>
            <a href="/profilesetting">
              <li className="hover_effect w-s-n-w p-y-1 p-x-1" role="menuitem">
                <AiFillSetting className="b-c-t" />
                &nbsp; Settings
              </li>
            </a>
            <li
              className="hover_effect w-s-n-w p-y-1 p-x-1"
              role="menuitem"
              onClick={() => toggleTheme()}
            >
              <MdOutlineDarkMode className="b-c-t" />
              &nbsp; Night Mode
            </li>
            <li
              className="hover_effect w-s-n-w p-y-1 p-x-1 pm-logout"
              role="menuitem"
              onClick={() => logout()}
            >
              <MdLogout className="b-c-t" />
              &nbsp; Logout
            </li>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
